import { z } from 'zod'

export const OrchestratedPaymentSchema = z.object({
  status: z.string(),
  retries: z.number().int().optional(),
  nextRetry: z.string().optional(),
  callerReferenceId: z.string(),
  updated: z.string(),
  created: z.string(),
  totals: z.object({
    amountInPenceIncludingTax: z.number().int(),
  }),
})

export const GetOrchestratedPaymentsResponseSchema = z.object({
  data: z.array(OrchestratedPaymentSchema),
  pageMeta: z.object({
    totalCount: z.number().int(),
    totalPages: z.number().int(),
    pageSize: z.number().int(),
    currentPage: z.number().int(),
  }),
})

export const PaymentCardSchema = z.object({
  lastFourDigits: z.string().length(4),
  fourDigitExpiryDate: z.string(),
  cardType: z.string(),
})
export const PaymentCardResponseSchema = z.array(PaymentCardSchema)

export const PaymentDetailSchema = z.object({
  id: z.string(),
  status: z.string(),
  amountInPence: z.number(),
  updatedAt: z.string(),
})

export const GetOrchestratedPaymentsRequestSchema = z.object({
  memberId: z.string().optional(),
  orderId: z.string().optional(),
  'status.in': z.array(z.string()).optional(),
  'domain.in': z.array(z.string()).optional(),
  'updated.from': z.string().optional(),
  'updated.to': z.string().optional(),
  page: z.number().int().optional(),
  size: z.number().int().optional(),
  sort: z.array(z.string()).optional(),
})

export const GetPaymentDetailRequestSchema = z
  .object({
    callerReferenceId: z.string().optional(),
  })
  .strip()

export const GetPaymentDetailResponseSchema = z.array(PaymentDetailSchema)
